import { z } from 'zod';
import { paginationSchema } from '@/types/pagination';

export const destinationSchema = z.object({
  id: z.string(),
  tenantId: z.string(),
  name: z.string(),
  slug: z.string(),
  description: z.string(),
  createdBy: z.object({
    id: z.string(),
    name: z.string(),
  }),
  createdAt: z.string(),
  updatedAt: z.string(),
  updatedBy: z.object({
    id: z.string(),
    name: z.string(),
  }),
});

export type Destination = z.infer<typeof destinationSchema>;

export const getDestinationsSchema = z.object({
  destinations: z.array(destinationSchema),
  pagination: paginationSchema.optional(),
});

export type GetDestination = z.infer<typeof getDestinationsSchema>;

export const destinationArraySchema = z.array(z.string());

export type setDestinationReturn = z.infer<typeof destinationArraySchema>;
